/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

// Dashboard example components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DataTable from "examples/Tables/DataTable";

// Dashboard components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDCard from "components/MDCard";
import MDInput from "components/MDInput";
import MDTypography from "components/MDTypography";

// @mui material components
import Alert from "@mui/material/Alert";
import Card from "@mui/material/Card";
import Collapse from "@mui/material/Collapse";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Modal from "@mui/material/Modal";
import Tooltip from "@mui/material/Tooltip";

import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";

// @mui material icons
import CloseIcon from "@mui/icons-material/Close";

// DatePicker components and  styling
import "react-datepicker/dist/react-datepicker.css";

import { StyleSheet } from "@react-pdf/renderer";
import { useReactToPrint } from "react-to-print";

// Utils
import TextError from "utils/TextError";

// Notification
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Formik and Yup
import { useFormik } from "formik";
import * as Yup from "yup";

// Functions from store
import {
  createDynamicColumn,
  createVendor,
  getDynamicColumn,
  getSubModulesByRoleId,
  getVendorsListForPlannerWithPagination,
  updateEmail,
} from "../../store";

// React-Select component and styling
import Config from "../../config/index";
import "../../index.css";

// Cookies
import Cookies from "universal-cookie";

const cookies = new Cookies();

let desLength = Config.descriptionLength;

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styleForCreateASN = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "70%", sm: "70%", md: "50%", lg: "90%", xl: "90%" },
  height: {
    xs: "fit-content",
    sm: "fit-content",
    md: "fit-content",
    lg: "fit-content",
    xl: "fit-content",
  },
  maxHight: "90%",
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const styleForDocument = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: 340, sm: 340, md: 600, lg: 800, xl: 800 },
  // height: { xs: "70%", sm: "70%", md: "50%", lg: "90%", xl: "90%" },
  overflow: "auto",
  maxHeight: "90%",
  boxShadow: 24,
  p: 1,
  pt: 3,
};

const styleForColumnReorder = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 380,
  color: "black",
  // border: "2px solid #000",
  boxShadow: 24,
  p: 2,
  pt: 3,
};

const styles = StyleSheet.create({
  page: {
    width: "100%",
    height: "100%",
    display: "flex",
    // flexDirection: "row",
    marginBottom: "50px",
    marginTop: "50px",
    // backgroundColor: '#E4E4E4'
  },
  section: {
    margin: 2,
    padding: 2,
    flexGrow: 1,
  },
});

const VendorMaster = ({
  getVendorsListForPlannerWithPagination,
  vendorsListForPlannerReducer,
  updateEmail,
  createVendor,
  getSubModulesByRoleId,
  getSubModulesByRoleIdReducer,
  getDynamicColumn,
  createDynamicColumn,
  getDynamicColumnReducer,
}) => {
  let user = cookies.get("loginDetailsForWMS");
  let roleName = user.data.roleName;
  let roleId = user.data.roleId;
  let userId = user.data.userId;
  let jwtToken = user?.jwt;

  useEffect(() => {
    getSubModulesByRoleId(roleId, jwtToken);
  }, [roleId]);

  const [modulesData, setModulesData] = useState([]);

  useEffect(() => {
    setModulesData(
      getSubModulesByRoleIdReducer.subModulesByRoleData.data
        ? getSubModulesByRoleIdReducer.subModulesByRoleData.data
        : [],
    );
  }, [getSubModulesByRoleIdReducer]);

  const subModuleId = "85af413b-b88b-411c-850c-0d7dfd9bd901";

  let dynamicColumnDetails = cookies.get("dynamic-column-data");

  let vendorMasterModule = modulesData.find(
    (moduleId) => moduleId.moduleId == "85af413b-b88b-411c-850c-0d7dfd9bd901",
  );

  let viewAccess = vendorMasterModule
    ? vendorMasterModule.actionId.includes(
        "fa721200-726d-4e8b-aaf7-14d205fedf71",
      )
    : null;

  let createAccess = vendorMasterModule
    ? vendorMasterModule.actionId.includes(
        "60584876-b76d-42d5-be57-dba85c7abf51",
      )
    : null;

  let addEmailAccess = vendorMasterModule
    ? vendorMasterModule.actionId.includes(
        "b6cfc022-fbc2-45cf-85d6-e1a32825ebe4",
      )
    : null;

  const [pageNo, setPageNo] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [searchObject, setSearchObject] = useState(JSON.stringify({}));
  const [paginationObj, setPaginationObj] = useState({});

  const importPageNo = (pageIndex) => {
    setPageNo(pageIndex === -1 ? pageNo : pageIndex);
  };

  const importRowsPerPage = (pageSize) => {
    setRowsPerPage(pageSize);
  };

  const importSearch = (globalFilter) => {
    setSearchObject(globalFilter ? JSON.stringify(globalFilter) : "");
  };

  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  const [partNoSelected, setPartNoSelected] = useState("");
  const [plantSelected, setPlantSelected] = useState("");
  const [vendorsListForPlannerSelected, setVendorsListForPlannerSelected] =
    useState("");

  const [asnQtyChange, setAsnQtyChange] = useState("");

  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  useEffect(() => {
    const isoStartDate = new Date(
      (startDate ? startDate : new Date()).getTime() -
        (startDate ? startDate : new Date()).getTimezoneOffset() * 60000,
    ).toISOString();

    setEndDate(isoStartDate);
  }, [startDate]);

  let today = new Date();

  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  var yyyy = today.getFullYear();

  let currentDate = yyyy + "-" + mm + "-" + dd;

  useEffect(() => {
    viewAccess &&
      getVendorsListForPlannerWithPagination(
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
  }, [viewAccess, pageNo, rowsPerPage, searchObject]);

  const [state, setState] = useState({
    columns: [
      {
        Header: "Supplier CODE",
        accessor: "vendorCode",
        align: "left",
      },
      { Header: "Supplier NAME", accessor: "vendorName", align: "left" },
      { Header: "Supplier Email", accessor: "email", align: "left" },

      {
        Header: "Action",
        accessor: "action",
        align: "center",
        cannotSearch: true,
        cannotSort: true,
      },
    ],
    rows: [],
  });

  const { columns, rows } = state;

  useEffect(() => {
    let tempDailyDemand = [];
    let data = vendorsListForPlannerReducer.vendorsListForPlannerData.data
      ? vendorsListForPlannerReducer.vendorsListForPlannerData.data
      : [];

    setLoading(vendorsListForPlannerReducer.loading);
    setPaginationObj(
      vendorsListForPlannerReducer.vendorsListForPlannerData.pagination,
    );
    data.map((singleData) => {
      let des = singleData?.itemDescription;
      let len = desLength;
      const formatDate = new Date(singleData.date);

      const dataObject = {
        id: singleData.id,
        partNoDes: `${singleData.itemCode} / ${
          des ? des.substring(0, len) : ""
        }`,
        partCode: singleData.itemCode,
        partDescription: singleData.itemDescription,

        vendorCode: singleData.vendorCode,
        vendorName: singleData.vendorName,
        email: singleData.email,
        action: (
          <div>
            {/* {role == "vendor" ? ( */}
            {singleData.status === 1 && createAccess && (
              <Tooltip title="Submit & Create">
                <MDButton
                  variant="gradient"
                  color="success"
                  type="button"
                  onClick={() => {
                    handleOpenCreateVendorModal(singleData);
                  }}
                  style={{ width: "130px", marginRight: "5px", padding: "2%" }}
                >
                  Submit & Create
                </MDButton>
              </Tooltip>
            )}
            {singleData.status === 0 && addEmailAccess && (
              <Tooltip title="Add Email">
                <MDButton
                  variant="gradient"
                  color="info"
                  type="button"
                  onClick={() => {
                    handleOpenAddEmailModal(singleData);
                  }}
                  style={{ width: "130px", marginRight: "5px", padding: "2%" }}
                >
                  Add Email
                </MDButton>
              </Tooltip>
            )}
            {singleData.status === 2 && (
              <Tooltip title="Add Email">
                <MDButton
                  disabled
                  variant="gradient"
                  color="success"
                  type="button"
                  // onClick={() => {

                  //   handleOpenCreateASNModal(singleData);
                  // }}
                  style={{ width: "130px", marginRight: "5px", padding: "2%" }}
                >
                  Created
                </MDButton>
              </Tooltip>
            )}
          </div>
        ),
      };

      tempDailyDemand.push(dataObject);
    });
    setState({ ...state, rows: tempDailyDemand });
  }, [vendorsListForPlannerReducer]);

  const [loading, setLoading] = useState(true);

  const VendorCreationNotification = () =>
    toast.success("Supplier Created Successfully", {
      position: "top-center",
      autoClose: 2000,
    });

  const [openAddEmailModal, setOpenAddEmailModal] = useState(false);
  const [singleVendorMasterData, setSingleVendorMasterData] = useState({});
  const handleOpenAddEmailModal = (data = {}) => {
    setSingleVendorMasterData(data);
    setOpenAddEmailModal(true);
    setIsErrorForAddEmail(false);
    setIsSuccessForAddEmail(false);
  };
  const handleCloseAddEmailModal = () => {
    setOpenAddEmailModal(false);
    formikForAddEmail.setErrors({});
  };

  const [errorMsgForAddEmail, setErrorMsgForAddEmail] = useState("");
  const [isErrorForAddEmail, setIsErrorForAddEmail] = useState(false);
  const [isSuccessForAddEmail, setIsSuccessForAddEmail] = useState(false);
  const [buttonName, setButtonName] = useState("Submit");
  useEffect(() => {
    if (isErrorForAddEmail) {
      setTimeout(() => {
        setIsErrorForAddEmail(false);
      }, 3000);
    }
  }, [isErrorForAddEmail]);

  useEffect(() => {
    if (isSuccessForAddEmail) {
      setTimeout(() => {
        setIsSuccessForAddEmail(false);
      }, 3000);
    }
  }, [isSuccessForAddEmail]);

  const initialValueForAddEmail = {
    email: singleVendorMasterData.email,
  };

  const validationSchemaForAddEmail = Yup.object({
    email: Yup.string().required("Enter a valid remark"),
  });

  const onSubmitForAddEmail = async (values) => {
    setButtonName("Please wait...");
    let payload = {
      id: singleVendorMasterData.id,
      email: values.email,
    };

    let res = await updateEmail(payload, jwtToken);
    if (res.status) {
      setIsSuccessForAddEmail(true);
      getVendorsListForPlannerWithPagination(
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
      setTimeout(() => {
        handleCloseAddEmailModal();
        setButtonName("Submit");
      }, 2250);
    }
    if (!res.status) {
      setIsErrorForAddEmail(true);
      setErrorMsgForAddEmail(res?.data?.data?.msg);
      setButtonName("Submit");
    }
  };

  const formikForAddEmail = useFormik({
    initialValues: initialValueForAddEmail,
    onSubmit: onSubmitForAddEmail,
    validationSchema: validationSchemaForAddEmail,
    enableReinitialize: true,
  });

  const [openCreateVendorModal, setOpenCreateVendorModal] = useState(false);

  const handleOpenCreateVendorModal = (data = {}) => {
    setSingleVendorMasterData(data);
    setOpenCreateVendorModal(true);
    setIsErrorForCreateVendor(false);
    setIsSuccessForCreateVendor(false);
  };
  const handleCloseCreateVendorModal = () => {
    setOpenCreateVendorModal(false);
  };

  const [isErrorForCreateVendor, setIsErrorForCreateVendor] = useState(false);
  const [isSuccessForCreateVendor, setIsSuccessForCreateVendor] =
    useState(false);

  useEffect(() => {
    if (isErrorForCreateVendor) {
      setTimeout(() => {
        setIsErrorForCreateVendor(false);
      }, 3000);
    }
  }, [isErrorForCreateVendor]);

  useEffect(() => {
    if (isSuccessForCreateVendor) {
      setTimeout(() => {
        setIsSuccessForCreateVendor(false);
      }, 3000);
    }
  }, [isSuccessForCreateVendor]);

  const HandleCreateVendor = async () => {
    let payload = {
      id: singleVendorMasterData.id,
      email: singleVendorMasterData.email,
      vendorName: singleVendorMasterData.vendorName,
    };

    let res = await createVendor(payload, jwtToken);
    if (res.status) {
      VendorCreationNotification();
      handleCloseCreateVendorModal();
      setIsSuccessForCreateVendor(true);
      getVendorsListForPlannerWithPagination(
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
    }
    if (!res.status) {
      setIsErrorForCreateVendor(true);
    }
  };

  const [disableButton, setDisableButton] = useState(false);
  const [loadingForDynamicColumn, setLoadingForDynamicColumn] = useState(false);
  useEffect(() => {
    getDynamicColumn(userId, subModuleId, jwtToken);
  }, [userId, subModuleId]);

  const [dynamicColumnData, setDynamicColumnData] = useState("");

  let hiddenColumsDetails = cookies.get("hidden-column-data");
  useEffect(() => {
    let data = getDynamicColumnReducer.dynamicColumn.data
      ? getDynamicColumnReducer.dynamicColumn.data
      : [];

    setDynamicColumnData(data);
    cookies.set("hidden-column-data", JSON.stringify(data?.notVisibleFields), {
      path: "/",
    });

    setTimeout(() => {
      setLoadingForDynamicColumn(true);
    }, 1000);
  }, [getDynamicColumnReducer, loading]);

  const [openCreateColumnReorderModal, setOpenCreateColumnReorderModal] =
    useState(false);

  const handleOpenCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(true);
  };

  const handleCloseCreateColumnReorderModal = () => {
    setOpenCreateColumnReorderModal(false);
  };

  const [isErrorColumnReorder, setIsErrorColumnReorder] = useState(false);
  const [isSuccessColumnReorder, setIsSuccessColumnReorder] = useState(false);

  useEffect(() => {
    if (isErrorColumnReorder) {
      setTimeout(() => {
        setIsErrorColumnReorder(false);
      }, 3000);
    }
  }, [isErrorColumnReorder]);

  useEffect(() => {
    if (isSuccessColumnReorder) {
      setTimeout(() => {
        setIsSuccessColumnReorder(false);
      }, 3000);
    }
  }, [isSuccessColumnReorder]);

  const [isErrorMsgForColumnReorder, setIsErrorMsgForColumnReorder] =
    useState(false);

  const handleDynamicColumn = async () => {
    let res = await createDynamicColumn(dynamicColumnDetails, jwtToken);
    if (res.status) {
      setIsSuccessColumnReorder(true);
      getDynamicColumn(userId, subModuleId, jwtToken);
      getVendorsListForPlannerWithPagination(
        pageNo,
        rowsPerPage,
        searchObject,
        jwtToken,
      );
      setTimeout(() => {
        handleCloseCreateColumnReorderModal();
        // window.location.reload();
      }, 2250);
    }
    if (!res.status) {
      setIsErrorColumnReorder(true);
      setIsErrorMsgForColumnReorder(res?.data?.data?.msg);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={0} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={3}
                mb={-5}
                mt={-4}
              >
                <MDBox></MDBox>
              </MDBox>
              <MDBox
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                p={3}
                mb={-6}
              >
                <MDBox>
                  <MDBox
                    flexDirection={{
                      xs: "column",
                      sm: "column",
                      md: "row",
                      lg: "row",
                      xl: "row",
                    }}
                    style={{ display: "flex" }}
                    mb={2}
                    ml={0}
                  ></MDBox>
                </MDBox>
              </MDBox>

              <MDBox pt={1}>
                <DataTable
                  table={{ columns, rows }}
                  isSorted
                  tableSearch
                  showTotalEntries
                  noEndBorder
                  loading={loading}
                  entriesPerPage={{
                    defaultValue: 5,
                    entries: [5, 10, 15, 20, 25, 30],
                  }}
                  serverSidePagination
                  paginationObj={paginationObj}
                  pageNoValue={pageNo}
                  rowsPerPageValue={rowsPerPage}
                  pageNoProp={importPageNo}
                  rowsPerPageProp={importRowsPerPage}
                  searchProp={importSearch}
                  visibleColumns2={dynamicColumnData?.visibleFields}
                  dynamicColumnData={dynamicColumnData}
                  options={{ draggable: false }}
                  handleOpenCreateColumnReorderModal={
                    handleOpenCreateColumnReorderModal
                  }
                  subModuleId={subModuleId}
                  userId={userId}
                  disableButton={disableButton}
                />
              </MDBox>
              <Modal
                open={openAddEmailModal}
                onClose={handleCloseAddEmailModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={style}>
                  <MDBox ml={3} mt={-1} display="flex" alignItems="center">
                    <MDTypography variant="h4" fontWeight="medium" flexGrow={1}>
                      Add Email
                    </MDTypography>
                    <MDBox>
                      <Tooltip title="Close">
                        <IconButton
                          aria-label="close"
                          color="inherit"
                          onClick={handleCloseAddEmailModal}
                          style={{
                            background: "whitesmoke",
                            color: "black",
                            borderRadius: 5,
                            marginLeft: "-55px",
                          }}
                        >
                          <CloseIcon />
                        </IconButton>
                      </Tooltip>
                    </MDBox>
                  </MDBox>
                  <hr style={{ marginTop: "0.5rem", marginBottom: "1rem" }} />

                  <MDBox pt={1} pb={3} px={3}>
                    <MDBox
                      component="form"
                      role="form"
                      onSubmit={formikForAddEmail.handleSubmit}
                    >
                      <MDBox mb={2}>
                        <MDTypography variant="h6">Email</MDTypography>
                        <MDInput
                          type="email"
                          name="email"
                          fullWidth
                          autoComplete="off"
                          onBlur={formikForAddEmail.handleBlur}
                          onChange={formikForAddEmail.handleChange}
                          value={formikForAddEmail.values.remark}
                          error={
                            formikForAddEmail.touched.remark &&
                            formikForAddEmail.errors.remark &&
                            true
                          }
                        />
                        {formikForAddEmail.touched.remark &&
                          formikForAddEmail.errors.remark && (
                            <TextError msg={formikForAddEmail.errors.remark} />
                          )}
                      </MDBox>

                      <MDBox>
                        <Collapse in={isErrorForAddEmail}>
                          <Alert
                            severity="error"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorForAddEmail(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            {errorMsgForAddEmail}
                          </Alert>
                        </Collapse>
                        <Collapse in={isSuccessForAddEmail}>
                          <Alert
                            severity="success"
                            action={
                              <IconButton
                                aria-label="close"
                                color="inherit"
                                size="small"
                                onClick={() => {
                                  setIsErrorForAddEmail(false);
                                }}
                              >
                                <CloseIcon fontSize="inherit" />
                              </IconButton>
                            }
                          >
                            Email added successfully
                          </Alert>
                        </Collapse>
                      </MDBox>
                      <MDBox mt={3}>
                        <MDButton
                          variant="contained"
                          color="info"
                          fullWidth
                          type="submit"
                          disabled={
                            !formikForAddEmail.isValid ||
                            buttonName === "Please wait..."
                          }
                        >
                          {buttonName}
                        </MDButton>
                      </MDBox>
                    </MDBox>
                  </MDBox>
                </MDCard>
              </Modal>

              <Modal
                open={openCreateColumnReorderModal}
                onClose={handleCloseCreateColumnReorderModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                style={{ backdropFilter: "blur(5px)" }}
              >
                <MDCard sx={styleForColumnReorder}>
                  <MDTypography>Are you sure you want to submit?</MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "10rem", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateColumnReorderModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "10rem", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={handleDynamicColumn}
                      // disabled={denyButtonName === "Please wait..."}
                    >
                      Submit
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isSuccessColumnReorder}>
                      <Alert
                        severity="success"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsSuccessColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Data updated successfully!
                      </Alert>
                    </Collapse>
                    <Collapse in={isErrorColumnReorder}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorColumnReorder(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        {isErrorMsgForColumnReorder}
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>

              <Modal
                open={openCreateVendorModal}
                onClose={handleCloseCreateVendorModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
              >
                <MDCard sx={style}>
                  <MDTypography>
                    Are you sure you want to create supplier?
                  </MDTypography>
                  <MDBox mt={2}>
                    <MDButton
                      style={{ width: "48%", marginRight: "0.5rem" }}
                      color="info"
                      variant="outlined"
                      onClick={handleCloseCreateVendorModal}
                    >
                      Cancel
                    </MDButton>
                    <MDButton
                      style={{ width: "48%", marginLeft: "0.5rem" }}
                      color="success"
                      onClick={HandleCreateVendor}
                    >
                      Create
                    </MDButton>
                  </MDBox>
                  <MDBox mt={2}>
                    <Collapse in={isErrorForCreateVendor}>
                      <Alert
                        severity="error"
                        action={
                          <IconButton
                            aria-label="close"
                            color="inherit"
                            size="small"
                            onClick={() => {
                              setIsErrorForCreateVendor(false);
                            }}
                          >
                            <CloseIcon fontSize="inherit" />
                          </IconButton>
                        }
                      >
                        Could not Create the supplier
                      </Alert>
                    </Collapse>
                  </MDBox>
                </MDCard>
              </Modal>
            </Card>
          </Grid>
        </Grid>
        {loading && (
          <Backdrop
            sx={{ color: "blue", zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open
          >
            <CircularProgress color="inherit" />
          </Backdrop>
        )}
        <ToastContainer />
      </MDBox>
    </DashboardLayout>

    //  <Footer />
  );
};

const mapStateToProps = (state) => {
  return {
    getSubModulesByRoleIdReducer: state.getSubModulesByRoleIdReducer,
    vendorsListForPlannerReducer:
      state.vendorsListForPlannerWithPaginationReducer,

    getDynamicColumnReducer: state.getDynamicColumnReducer,
  };
};

const mapStateToDispatch = (dispatch) => {
  return {
    getSubModulesByRoleId: (roleId, jwtToken) =>
      dispatch(getSubModulesByRoleId(roleId, jwtToken)),
    getVendorsListForPlannerWithPagination: (
      pageNo,
      rowsPerPage,
      searchObject,
      jwtToken,
    ) =>
      dispatch(
        getVendorsListForPlannerWithPagination(
          pageNo,
          rowsPerPage,
          searchObject,
          jwtToken,
        ),
      ),
    updateEmail: (payload, jwtToken) =>
      dispatch(updateEmail(payload, jwtToken)),
    createVendor: (payload, jwtToken) =>
      dispatch(createVendor(payload, jwtToken)),
    getDynamicColumn: (userId, subModuleId, jwtToken) =>
      dispatch(getDynamicColumn(userId, subModuleId, jwtToken)),
    createDynamicColumn: (payload, jwtToken) =>
      dispatch(createDynamicColumn(payload, jwtToken)),
  };
};

export default connect(mapStateToProps, mapStateToDispatch)(VendorMaster);
